import axios from 'axios';
import { API } from './api';

/**
 * Track money-flow event.
 * Fire-and-forget — never blocks UI.
 */
export const trackEvent = (event, meta = {}) => {
  const token = localStorage.getItem('token');
  if (!token) return;
  axios.post(`${API}/events/track`, { event, meta }, {
    headers: { Authorization: `Bearer ${token}` },
  }).catch(() => {});
};
